function getCart() {
  return fetch(''.concat('/cart.js', '?t=').concat(Date.now()), { credentials: 'same-origin', method: 'GET' }).then(response => response.json());
}

function isTrialSelected() {
  return new Promise((resolve) => {
    setTimeout(() => {
      const selectedOption = document.querySelector(
        '[data-variant-picker-option-labels][option-picker-name="duration" i] .pill.selected .pill__label'
      );

      const result = selectedOption?.textContent?.toLowerCase().includes('trial') || false;

      resolve(result);
    }, 50);
  });
}

function updateTrialText() {
  const selectedPill = document.querySelector('[option-picker-name="Duration"] .pill.selected');
  const priceEl = document.querySelector('.rent-var-pricing small');

  if (!selectedPill || !priceEl) return;

  const labelText = selectedPill.querySelector('.pill__label')?.textContent.trim();

  if (labelText === 'Home trial') {
    setTimeout(function () {
      priceEl.textContent = '(1 hour home trial)';
    });
  }
}

document.addEventListener('DOMContentLoaded', updateTrialText);

document.querySelectorAll('[option-picker-name="duration" i] .pill').forEach(pill => {
  pill.addEventListener('click', updateTrialText);
});

function addTrialProduct() {
  const productForm = document.querySelector('.template-product [data-type="add-to-cart-form"]');
  if (!productForm) return;

  let add_to_cart = productForm.querySelector('.product-form__btn');

  add_to_cart.addEventListener('click', async function (e) {

    const trial = await isTrialSelected();

    if (!trial()) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    const cart = await getCart();
    const trialCount = countTrialProducts(cart);

    if (trialCount >= 3) {
      alert("You can't add more than 3 trial products at once.");
    } else {
      productForm.submit();
    }
  });
}

function updateButtonText(isTrial) {
  const button = document.querySelector('.main-product--form .product-form__btn');

  if (!button) return;

  let textSpan = button.querySelector('[data-button-text]');

  if (!textSpan) {
    textSpan = document.createElement('span');
    textSpan.setAttribute('data-button-text', '');
    button.prepend(textSpan); 
  }

  textSpan.textContent = isTrial ? 'Book Trial' : 'Rent Now';
}

function countTrialProducts(cart) {
  if (!cart?.items) return 0;

  let trialCount = 0;

  cart.items.forEach(item => {
    const isTrial = item.options_with_values?.some(option => option.name.toLowerCase() === "duration" && option.value.toLowerCase().includes("trial"));

    if (isTrial) { trialCount += item.quantity; }
  });

  return trialCount;
}

function waitForIzyReady() {
  return new Promise((resolve) => {
    const button = document.querySelector('.main-product--form .product-form__btn');
    if (!button) return resolve(false);

    const observer = new MutationObserver(() => {
      if (button.classList.contains('izyReady')) {
        observer.disconnect();
        resolve(true);
      }
    });

    observer.observe(button, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
}

async function updateUI() {
  const terms = document.querySelector('.trial--terms');
  const trial = await isTrialSelected();

  if (!terms) return;

  terms.classList.toggle('active', trial);
  updateButtonText(trial);
}

function trialTerms() {
  const labels = document.querySelectorAll('[data-variant-picker-option-labels][option-picker-name="duration" i] label');

  if (!labels.length) return;

  updateUI();

  labels.forEach(label => {
    label.addEventListener('click', async function () {
      setTimeout(updateUI, 500); 
      await waitForIzyReady();
      updateUI();               
    });
  });
}

document.addEventListener('DOMContentLoaded', trialTerms);

document.addEventListener('DOMContentLoaded', function(){
  addTrialProduct();
  trialTerms();
});